import { useState } from "react";
import { Api } from "../api/Api";
import {useErrorWebhook} from "./useErrorWebhook";

export const useLenderName = () => {
  const { ErrorWebhookTrigger } = useErrorWebhook();

  const getLenderName= async (
    uuid
  ) => {
    const response = await Api.post("api/v1/get-lender-name", {
      uuid
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'GET LENDER NAME',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid

      }
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };
  return { getLenderName };
};
